import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

interface IMenuItem {
  type: string,       // Possible values: link/dropDown/icon/separator/extLink
  name?: string,      // Used as display text for item and title for separator type
  state?: string,     // Router state
  user_type?:string,
  icon?: string,      // Material icon name
  tooltip?: string,   // Tooltip text 
  disabled?: boolean, // If true, item will not be appeared in sidenav.
  sub?: IChildItem[], // Dropdown items
  badges?: IBadge[],

}
interface IChildItem {
  type?: string,
  name: string,       // Display text
  state?: string,     // Router state
  icon?: string,
  sub?: IChildItem[]
}

interface IBadge {
  color: string;      // primary/accent/warn/hex color codes(#fff000)
  value: string;      // Display text
}

@Injectable()
export class NavigationService {
  constructor() { }

  defaultMenu: IMenuItem[] = [
    {
      name: 'หน้าหลัก',
      type: 'link',
      tooltip: 'Dashboard',
      icon: 'dashboard',
      state: 'dashboard',
      user_type:'1'
    },
    {
      name: 'ขอใช้รถยนต์',
      type: 'link',
      tooltip: 'ข้อมูลการขอใช้รถ',
      icon: 'assignment_turned_in',
      state: 'addbookingdata',
      user_type:'1'
    },{
      name: 'ปฏิทินการขอใช้รถยนต์',
      type: 'link',
      tooltip: 'ปฏิทินการขอใช้รถยนต์',
      icon: 'event_available',
      state: 'reportbookingdata',
      user_type:'1'
    },
    {
      name: 'ข้อมูลรถยนต์และคนขับรถ',
      type: 'link',
      tooltip: 'ข้อมูลรถยนต์และคนขับรถ',
      icon: 'directions_bus',
      state: 'cardriverdata',
      user_type:'2'
    },
    {
      name: 'งานรออนุมัติ',
      type: 'link',
      tooltip: 'อนุมัติการขอใช้รถ',
      icon: 'do_not_disturb_on',
      state: 'bookingapprove',
      user_type:'2'
    },
    {
      name: 'งานนุมัติแล้ว',
      type: 'link',
      tooltip: 'อนุมัติการขอใช้รถ',
      icon: 'check_circle',
      state: 'bookingapprove2',
      user_type:'2'
    },
    {
      name: 'รายงานข้อมูลการให้บริการ',
      type: 'link',
      tooltip: 'อนุมัติการขอใช้รถ',
      icon: 'assessment',
      state: 'reportbooking',
      user_type:'2'
    },
    {
      name: 'คู่มือการใช้งานระบบ',
      type: 'extLink',
      tooltip: 'Documentation',
      icon: 'library_books',
      state: 'http://egret-doc.mhrafi.com/',
      user_type:'1'
    }
  ]

  // Icon menu TITLE at the very top of navigation.
  // This title will appear if any icon type item is present in menu.
  iconTypeMenuTitle: string = 'Frequently Accessed';
  // sets iconMenu as default;
  menuItems = new BehaviorSubject<IMenuItem[]>(this.defaultMenu);
  // navigation component has subscribed to this Observable
  menuItems$ = this.menuItems.asObservable();

  // Customizer component uses this method to change menu.
  // You can remove this method and customizer component.
  // Or you can customize this method to supply different menu for
  // different user type.
  publishNavigationChange(menuType: string) {
    this.menuItems.next(this.defaultMenu);
  }
}


// WEBPACK FOOTER //
// D:/Programing/carbooking/src/app/shared/services/navigation.service.ts